module.exports = __webpack_public_path__ + "img/favorite.b0bd1a21.svg";